import { GD } from "src/GD";

/**
 * KYC flow (task M-15).
 *
 * start  -> POST /kyc/start  -> { verification_url }
 * status -> POST /kyc/status -> independent our/provider KYC statuses
 *
 * Auth header (Bearer <buyer_token>) is attached automatically in HTTP.requestAPI.
 */
export class KycService {
	constructor() {
		GD.REQ_KYC_START.listener = this.start;
		GD.REQ_KYC_STATUS.listener = this.status;
		GD.REQ_KYC_ISSUERS.listener = this.issuers;
		GD.REQ_KYC_PHONE_GET.listener = this.phoneGet;
		GD.REQ_KYC_PHONE.listener = this.phoneSave;
	}

	private start: (body: void | IKycStartBody) => Promise<IAPIResponse<IKycStartResponse>> = async body => {
		return (await GD.REQ_API.request({
			httpMethod: "POST",
			method: "kyc/start",
			data: body ?? {},
		})) as IAPIResponse<IKycStartResponse>;
	};

	private status: (body: void | IKycStatusRequest) => Promise<IAPIResponse<IKycStatusResponse>> = async body => {
		return (await GD.REQ_API.request({
			httpMethod: "POST",
			method: "kyc/status",
			data: body ?? {},
		})) as IAPIResponse<IKycStatusResponse>;
	};

	/**
	 * Connected issuers with their per-KYC status. Provider names are masked
	 * ("Issuer N") in this user-facing endpoint.
	 */
	private issuers: (body: void | IKycStatusRequest) => Promise<IAPIResponse<IKycIssuer[]>> = async body => {
		return (await GD.REQ_API.request({
			httpMethod: "POST",
			method: "kyc/issuers",
			data: body ?? {},
		})) as IAPIResponse<IKycIssuer[]>;
	};

	private phoneGet: (body: void | IKycPhoneRequest) => Promise<IAPIResponse<any>> = async body => {
		return (await GD.REQ_API.request({
			httpMethod: "POST",
			method: "kyc/phone/get",
			data: body ?? {},
		})) as IAPIResponse<any>;
	};

	private phoneSave: (body: IKycPhoneBody) => Promise<IAPIResponse<any>> = async body => {
		return (await GD.REQ_API.request({
			httpMethod: "POST",
			method: "kyc/phone",
			data: body,
		})) as IAPIResponse<any>;
	};
}
